"use client";

import { Link2, Wallet } from "lucide-react";
import { Web3ModalProvider } from "@/components/web3modal-provider";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { MainnetWalletLinkCard } from "../campaigns/_components/campaign-pages";

function LinkedWalletsPageContent() {
  const { address, isAuthenticated, isLoading, login } = useAuth();

  return (
    <main className="min-h-screen bg-white px-5 py-10 md:py-14">
      <div className="mx-auto max-w-3xl">
        <div className="mb-8">
          <div className="mb-4 inline-flex items-center gap-2 border border-spicenet-primary/25 bg-spicenet-primary/5 px-3 py-2 font-mono text-xs font-semibold uppercase tracking-[0.12em] text-spicenet-primary">
            <Link2 className="h-4 w-4" />
            Wallet Linking
          </div>
          <h1 className="text-3xl font-medium tracking-[-1px] text-spicenet-black md:text-4xl">
            Linked Wallets
          </h1>
          <p className="mt-4 max-w-2xl text-sm font-medium leading-6 text-spicenet-gray">
            Add a secondary wallet to your Portal account so campaign access and
            Reppo activity can resolve to the same user.
          </p>
        </div>

        {!isAuthenticated && !isLoading ? (
          <section className="relative border border-spicenet-ash bg-white p-7">
            <span className="absolute left-2 top-2 h-1.5 w-1.5 bg-spicenet-black" />
            <span className="absolute right-2 top-2 h-1.5 w-1.5 bg-spicenet-black" />
            <span className="absolute bottom-2 left-2 h-1.5 w-1.5 bg-spicenet-black" />
            <span className="absolute bottom-2 right-2 h-1.5 w-1.5 bg-spicenet-black" />
            <div className="mb-5 flex items-center gap-4">
              <span className="flex h-10 w-10 items-center justify-center bg-spicenet-primary/15 text-spicenet-primary">
                <Wallet className="h-5 w-5" />
              </span>
              <h2 className="text-sm font-semibold uppercase tracking-[0.08em] text-spicenet-dark">
                Connect Portal Wallet
              </h2>
            </div>
            <p className="mb-6 text-sm font-medium leading-6 text-spicenet-gray">
              Connect your Portal wallet first, then link a secondary wallet.
            </p>
            <Button variant="primary" className="w-full" onClick={login}>
              Connect Wallet
            </Button>
          </section>
        ) : (
          <MainnetWalletLinkCard
            address={address}
            walletTitle="Linked Wallets"
            walletDescription="Link a secondary wallet to your Portal account. Use this when your app wallet differs from your Portal wallet, or when you need to move campaign access to a fresh wallet."
            walletNote="Wallets linked here are treated as part of the same campaign identity."
          />
        )}
      </div>
    </main>
  );
}

export default function LinkedWalletsPage() {
  return (
    <Web3ModalProvider>
      <LinkedWalletsPageContent />
    </Web3ModalProvider>
  );
}
